import * as React from 'react';
import { CSSProperties } from 'react';

const UploadProgress = ({status, progress}: {status: string, progress: number}) => {
  const color = {
    uploading: 'primary',
    complete: 'success',
    error: 'danger',
  }[status]

  const animated = (status == 'uploading');

  const label = {
    uploading: `Uploading... ${progress}%`,
    complete: 'Uploaded',
    error: 'There was an error',
  }[status]
   
   return (
     <div className="progress mt-2"><div className={`progress-bar bg-${color}${animated ? ' progress-bar-striped progress-bar-animated' : ''}`} role="progressbar" style={{width: `${progress}%`}}>{label}</div></div>
   );
}

const imgContainerStyle: CSSProperties = {
  position: 'relative',
  overflow:'hidden',
  paddingBottom: '100%',
}

const imgStyle: CSSProperties =  {
    position: 'absolute',
    maxWidth: '100%',
    maxHeight: '100%',
    top: '50%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)',
}



const removeBtnStyle: CSSProperties = {
  position: 'absolute',
  top: 10,
  right: 10,
}

const PhotoUpload = ({
  imageData, 
  status, 
  progress,
  token, 
  onRemove
}: {imageData: string, status: string, progress: number, token: string, onRemove: () => void}) => {
   return (
     <div className="col-lg-3 col-md-4 col-sm-6" style={{minWidth: 300}}> 
       <div className="card border"><div className="card-body">
         <div style={imgContainerStyle}>
           <img src={imageData} className="img-fluid full-width" 
             style={imgStyle} />
         </div>
         
         <UploadProgress  status={status} progress={progress} />
         
         { token && <button 
             className="btn btn-danger btn-sm"
             style={removeBtnStyle}
             onClick={onRemove}>Remove</button> }
       </div></div>
     </div>
   )
}

export default PhotoUpload;
